import { render, staticRenderFns } from "./BlacklistedContacts.vue?vue&type=template&id=681c5ea9&scoped=true"
import script from "./BlacklistedContacts.vue?vue&type=script&lang=js"
export * from "./BlacklistedContacts.vue?vue&type=script&lang=js"
import style0 from "./BlacklistedContacts.vue?vue&type=style&index=0&id=681c5ea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681c5ea9",
  null
  
)

export default component.exports